import React, { Component } from 'react';
import GoogleLogin from 'react-google-login';
import FacebookLogin from 'react-facebook-login';
import Logo from '../../assets/images/kinship-logo.svg';
import Facebook from '../../assets/images/facebook.png';
import Google from '../../assets/images/google.png';
//import { BrowserRouter as Routes, Link } from 'react-router-dom';

export default class LoginPage extends Component {
    constructor(props) {
        super()
    }

    componentDidMount = ()=>{
//         var input = document.getElementById('txtLoginEmail');

// // Execute a function when the user releases a key on the keyboard
// input.addEventListener("keyup", function(event) {
//   // Number 13 is the "Enter" key on the keyboard
//   if (event.keyCode === 13) {
//     // Cancel the default action, if needed
//     event.preventDefault();

//    // alert('hhhh')
//     // Trigger the button element with a click
//     document.getElementById("btnLoginButton").click();
//   }
// });
   }
    render() {
        return (
            <div className='login'>
                <div className="container">
                    <div className="loginMainDiv" style={{ height: '100%' }}>
                        <div className="LogoDiv">
                            <img src={Logo} alt="logo" />
                        </div>
                        <div className='welcome-div'>
                            <h4 className='welcome'>Welcome</h4>
                            <p>Login to kinship</p>
                        </div>

                        <form style={{ paddingTop: '10px', textAlign: 'center' }}>
                            <div class="form-group"  >

                                <input type="email" class="form-control-ausi" id="txtLoginEmail" name="txtLoginEmail" value={this.props.txtLoginEmail} onChange={this.props.HandleLoginInputs}
                                onKeyDown={(e)=>this.props.CheckLogin(e)}
                                placeholder="Enter email" />
                            </div>
                            <div class="form-group" >
                                <input type="password" class="form-control-ausi" id="txtLoginPassword" name="txtLoginPassword" value={this.props.txtLoginPassword} onChange={this.props.HandleLoginInputs}
                                onKeyDown={(e)=>this.props.CheckLogin(e)}
                                placeholder="Password" />
                                <div class="cursor-pointer" style={{ textAlign: 'start', marginLeft: '10px', marginTop: '5px' }} onClick={() => this.props.HandleRouting('forgot-password')}>

                                    <small id="emailHelp" class="form-forgot-password">
                                        Forgot Password?</small>

                                </div>
                            </div>
                            {this.props.txtLoginValidationMessage !== '' ?
                                <div>
                                    <div className="ausaf-errorMessage">{this.props.txtLoginValidationMessage}</div>
                                </div> : null}
                            <button type="button" class="btn login-button" id="btnLoginButton" name="btnLoginButton" onClick={this.props.Login}>Log In</button>
                            <div className='signup-link-div'>
                                <div className="signup-link-text"><p>Don't have an account?</p></div>
                                <div className="sign-up-link cursor-pointer" onClick={() => this.props.HandleRouting('sign-up')}><p>Sign up</p></div>
                            </div>
                        </form>
                        <div className='login-page-partition'>
                            <div className='login-partition-line'></div>
                            <span>OR</span>
                            <div className='login-partition-line'></div>
                        </div>

                        <div className='social-login'>
                            <div className="google-login-btn" style={{ display: 'flex' }}>
                                <img className="social-login-btn-logo" src={Google} alt="google" />

                                <GoogleLogin
                                    clientId="833238440283-s64g3p22cvd7vfb00jmpv47i2kap8bvf.apps.googleusercontent.com"
                                    buttonText="Continue with Google"
                                    id="btnGoogleLoginButton"
                                    name="btnGoogleLoginButton"
                                   // scope= 'https://www.googleapis.com/auth/user.birthday.read https://www.googleapis.com/auth/user.gender.read https://www.googleapis.com/auth/userinfo.profile'
                                    autoLoad={false}
                                  //  approvalPrompt="force"
                                    onSuccess={this.props.responseSuccessGoogle}
                                    onFailure={this.props.responseFailureGoogle}
                                // cookiePolicy={'single_host_origin'}
                                />

                            </div>

                            <div className='facebook-login-btn'>
                                <img className="social-login-btn-logo" src={Facebook} alt="facebook" />
                                <FacebookLogin
                                    appId="873255453283482"
                                    autoLoad={false}
                                    textButton="Continue with Facebook"
                                    id="btnFacebookLoginButton"
                                    name="btnFacebookLoginButton"
                                    fields="name,email,picture"
                                    //onClick={componentClicked}
                                    callback={this.props.responseSuccessFacebook}
                                />
                            </div>

                        </div>
                    </div>

                </div>


            </div>

        )
    }
}